import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { conceptCheckPlayerPopup } from '../redux/common';

export default function useConceptCheckPlayer() {
  const dispatch = useDispatch();
  const conceptPopupInfo = useSelector(state => state.common.conceptCheckPlayer);

  // useCallback의 두번째 인자값이 없으므로 conceptPopupInfo은 무조건 초기값임
  const setConceptPopup = useCallback((data) => {
    dispatch(conceptCheckPlayerPopup(data ? data : conceptPopupInfo));
  }, []);

  return [
    conceptPopupInfo,
    setConceptPopup
  ];
}
